import React from "react";
import { Text } from "@fluentui/react-northstar";
import styled from "styled-components/macro";

const CellDate = ({ date = "" }) => {
    if (!date) return null;
    return <DateText content={date} />;
};

export default CellDate;

const DateText = styled(Text)`
    color: var(
        --light-theme-rest-foreground-default-foreground-242424,
        #242424
    );
    text-align: center;

    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */
`;
